import { Grid, useMediaQuery, useTheme } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import * as Cesium from "cesium";
import React from "react";
import { GeopickingButton } from "./GeopickingButton";
import GlobeTranslucencyButton from "./GlobeTranslucencyButton";
import MainMapButton from "./MainMapButton";
import MeasurementButton from "./MeasurementButton";
import MeasurementSimpleButton from "./MeasurementSimpleButton";

const useStyles = makeStyles((theme) => ({
  root: {
    position: "absolute",
    top: theme.spacing(2),
    left: theme.spacing(2),
    marginRight: theme.spacing(11),
    zIndex: theme.zIndex.speedDial,
    width: "auto",
  },
}));

type Props = {
  viewer: Cesium.Viewer;
};

const CesiumToolbar = ({ viewer }: Props): JSX.Element => {
  const classes = useStyles();
  const theme = useTheme();
  const isMediumOrSmaller = useMediaQuery(theme.breakpoints.down("lg"));

  return (
    <Grid
      container
      spacing={isMediumOrSmaller ? 1 : 2}
      alignItems="center"
      className={classes.root}
    >
      <Grid item>
        <MainMapButton />
      </Grid>
      <Grid item>
        <MeasurementSimpleButton />
      </Grid>
      <Grid item>
        <MeasurementButton />
      </Grid>
      <Grid item>
        <GlobeTranslucencyButton viewer={viewer} />
      </Grid>
      <Grid item>
        <GeopickingButton />
      </Grid>
    </Grid>
  );
};

export default CesiumToolbar;
